<template>
    <div>
        <div>
            <v-row><v-autocomplete label="Select Product" :items="products" v-model="product" @change="fetchProducts()"></v-autocomplete></v-row>
            <v-row><v-text-field v-model="product" label="Or Enter Product"></v-text-field><v-btn @click="fetchProducts()">Search</v-btn></v-row>

            <v-row><v-select label="Radius" :items="radius_items" v-model="radius" @change="fetchProducts()"></v-select></v-row>
        </div>
        <v-simple-table v-if="items !== []">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">Title</th>
                        <th class="text-left">Price</th>
                        <th class="text-left">Description</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                        <td>{{ item.title }}</td>
                        <td>{{ item.price }}</td>
                        <td>{{ item.description }}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
    import LineChart from "../components/LineChart"
    export default {
        components: {
            LineChart
        },
        data() {
            return {
                // product_search: "",
                products: [
                    "alocasia amazonica variegata",
                    "alocasia azlanii",
                    "alocasia black stem",
                    "alocasia black stem variegata",
                    "alocasia frydek variegata",
                    "alocasia golden",
                    "alocasia golden lutea",
                    "alocasia lutea",
                    "alocasia macrorrhiza",
                    "alocasia macrorrhiza variegata",
                    "alocasia purple princess",
                    "alocasia reginula",
                    "alocasia xanthosoma",
                    "alocasia xanthosoma variagated",
                    "anthurium clarinervium",
                    "anthurium luxurians",
                    "anthurium regale",
                    "bipennifolium variegata",
                    "calathea orbifolia",
                    "colocasia schott",
                    "dieffenbachia reflector",
                    "farfugium japonicum",
                    "florida beauty variegata",
                    "golden dragon variegata",
                    "goldene efeutute",
                    "herzblattblume",
                    "jose buono variegata",
                    "micans variegata",
                    "monstera adansonii mint",
                    "monstera deliciosa variegata",
                    "monstera minima",
                    "monstera obliqua",
                    "monstera peru",
                    "pedatum variegata",
                    "philodendron billietiae",
                    "philodendron billietiae variegata",
                    "philodendron bipennifolium variegata",
                    "philodendron brasil variegata",
                    "philodendron calkins gold",
                    "philodendron cobra standleyana variegata",
                    "philodendron el choco red",
                    "philodendron florida beauty",
                    "philodendron florida ghost",
                    "philodendron gloriosum",
                    "philodendron goeldii variegata",
                    "philodendron golden dragon",
                    "philodendron golden dragon variegata",
                    "philodendron green wonder",
                    "philodendron hederaceum",
                    "philodendron jose buono variegata",
                    "philodendron jungle fever variegata",
                    "philodendron mamei",
                    "philodendron melanochrysum",
                    "philodendron micans variegata",
                    "philodendron nangaritense variegata",
                    "philodendron narrow escape variegata",
                    "philodendron paraiso verde variegata",
                    "philodendron pedatum",
                    "philodendron pertusum variegata",
                    "philodendron peru",
                    "philodendron pink princess",
                    "philodendron plowmanii",
                    "philodendron purple congo",
                    "philodendron red beauty",
                    "philodendron ring of fire",
                    "philodendron rosa",
                    "philodendron scandens",
                    "philodendron scandens lime",
                    "philodendron selloum variegata",
                    "philodendron sodiroi variegata",
                    "philodendron spiritus-sancti variegata",
                    "philodendron splendid",
                    "philodendron squamiferum",
                    "philodendron tricolor princess",
                    "philodendron variegata",
                    "philodendron verrucosum",
                    "philodendron white knight",
                    "philodendron white princess",
                    "philodendron white wave",
                    "rhaphidophora tetrasperma",
                    "scindapsus marble queen",
                    "subhastatum variegata",
                    "syngonium albo variegata"
                ],
                radius: "50",
                radius_items: ["50", "100", "200"],
                product: "",
                items: [],
                showAddMessage: false,
                selectedFilters: [
                    { tags: [], filtername: "Type", selected: [], condition: "that.selectedFilters[0].selected.includes(row.type)" },
                    { tags: [], filtername: "Brand", selected: [], condition: "that.selectedFilters[1].selected.includes(row.brand)" },
                    { tags: [], filtername: "Preposition", selected: [], condition: "that.selectedFilters[2].selected.includes(row.preposition)" },
                    { tags: [], filtername: "Verb", selected: [], condition: "that.selectedFilters[3].selected.includes(row.verb)" },
                    { tags: [], filtername: "Adjective", selected: [], condition: "that.selectedFilters[4].selected.includes(row.adjective)" },
                    { tags: [], filtername: "Noun", selected: [], condition: "that.selectedFilters[5].selected.includes(row.noun)" },
                    { tags: [], filtername: "Transactional", selected: [], condition: "that.selectedFilters[6].selected.includes(row.transactional)" },
                    { tags: [], filtername: "Informative", selected: [], condition: "that.selectedFilters[7].selected.includes(row.informative)" },
                    { tags: [], filtername: "Color", selected: [], condition: "that.selectedFilters[8].selected.includes(row.color)" },
                    { tags: [], filtername: "Material", selected: [], condition: "that.selectedFilters[9].selected.includes(row.material)" }
                ],
                downloaded: false,
                showSelectMessage: false,
                tableBtnDisabled: true,
                selected: [],
                keywords: [],
                gradient: ["#42defa", "#e6b800"],
                pagination: { sortBy: "avgsv", descending: true },
                search: "",
                headers: [
                    {
                        text: "Keyword",
                        align: "left",
                        sortable: true,
                        value: "keyword",
                        width: "250"
                    },
                    {
                        text: "Google Searchvolume (avg. monthly)",
                        value: "avgsv",
                        align: "left",
                        sortable: true,
                        width: "150"
                    },
                    {
                        text: "Searchvolume Trend",
                        value: "trend",
                        width: "80"
                    }
                ],
                svminimum: 400,
                graphOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    annotation: {
                        annotations: [
                            {
                                type: "line",
                                mode: "vertical",
                                scaleID: "x-axis-0",
                                value: "",
                                borderColor: "grey",
                                borderWidth: 1.5,
                                label: {
                                    content: String.fromCharCode(parseInt("21E0", 16)) + " 2019 | 2018 " + String.fromCharCode(parseInt("21E2", 16)),
                                    enabled: true,
                                    position: "top"
                                }
                            }
                        ]
                    }
                },
                dataChart: {
                    selected: [],
                    labels: [],
                    datasets: [
                        {
                            label: "Umsätze pro Woche (SI & PottIT)",
                            backgroundColor: "#EB5E28",
                            borderColor: "grey",
                            pointBackgroundColor: "white",
                            borderWidth: 2,
                            pointBorderColor: "grey",
                            data: [],
                            hidden: false
                        }
                    ]
                },
                countGraph: 0,
                countGraph2: 0,
                graphloaded: false,
                cardData: {
                    title: "Google Searchvolume",
                    subtitle: "Analyze searchvolume of the last 12 month"
                },
                graphCardData: {
                    title: "Google Searchvolume",
                    subtitle: "Analyze searchvolume of the last 12 month"
                },
                auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH)
            }
        },
        methods: {
            resetFilter() {
                this.table1.subTitle = this.apiRows.length + " keywords"
                this.rows = this.apiRows
                // this.selectedFilters[0].tags = helper.cleanArray(this.apiType).sort();
                // this.selectedFilters[1].tags = helper.cleanArray(this.apiBrand).sort();
                // this.selectedFilters[2].tags = helper.cleanArray(this.apiPreposition).sort();
                // this.selectedFilters[3].tags = helper.cleanArray(this.apiVerb).sort();
                // this.selectedFilters[4].tags = helper.cleanArray(this.apiAdjective).sort();
                // this.selectedFilters[5].tags = helper.cleanArray(this.apiNoun).sort();
                // this.selectedFilters[6].tags = helper.cleanArray(this.apiTransactional).sort();
                // this.selectedFilters[7].tags = helper.cleanArray(this.apiInformative).sort();
                // this.selectedFilters[8].tags = helper.cleanArray(this.apiColor).sort();
                // this.selectedFilters[9].tags = helper.cleanArray(this.apiMaterial).sort();
                for (var apiCounter = 0; apiCounter < this.apiData.length; apiCounter++) {
                    this.selectedFilters[apiCounter].tags = this.$helpers.cleanArray(this.apiData[apiCounter].data).sort()
                }

                for (var selectCounter = 0; selectCounter < this.selectedFilters.length; selectCounter++) {
                    this.selectedFilters[selectCounter].selected.length = 0
                }
            },
            filterKeywords() {
                console.log("filter")
                console.log(this.selectedFilters)
                if (
                    this.selectedFilters[0].selected.length == 0 &&
                    this.selectedFilters[1].selected.length == 0 &&
                    this.selectedFilters[2].selected.length == 0 &&
                    this.selectedFilters[3].selected.length == 0 &&
                    this.selectedFilters[4].selected.length == 0 &&
                    this.selectedFilters[5].selected.length == 0 &&
                    this.selectedFilters[6].selected.length == 0 &&
                    this.selectedFilters[7].selected.length == 0 &&
                    this.selectedFilters[8].selected.length == 0 &&
                    this.selectedFilters[9].selected.length == 0
                ) {
                    this.table1.subTitle = this.apiRows.length + " keywords"
                    this.rows = this.apiRows
                    for (var tagCounter = 0; tagCounter < this.selectedFilters.length; tagCounter++) {
                        this.selectedFilters[tagCounter].tags = this.$helpers.cleanArray(this.apiData[tagCounter].data).sort()
                    }
                    // this.selectedFilters[0].tags = helper.cleanArray(this.apiType).sort();
                    // this.selectedFilters[1].tags = helper.cleanArray(this.apiBrand).sort();
                    // this.selectedFilters[2].tags = helper.cleanArray(this.apiPreposition).sort();
                    // this.selectedFilters[3].tags = helper.cleanArray(this.apiVerb).sort();
                    // this.selectedFilters[4].tags = helper.cleanArray(this.apiAdjective).sort();
                    // this.selectedFilters[5].tags = helper.cleanArray(this.apiNoun).sort();
                    // this.selectedFilters[6].tags = helper.cleanArray(this.apiTransactional).sort();
                    // this.selectedFilters[7].tags = helper.cleanArray(this.apiInformative).sort();
                    // this.selectedFilters[8].tags = helper.cleanArray(this.apiColor).sort();
                    // this.selectedFilters[9].tags = helper.cleanArray(this.apiMaterial).sort();
                } else {
                    var conditions = []
                    for (var conditionCounter = 0; conditionCounter < this.selectedFilters.length; conditionCounter++) {
                        if (this.selectedFilters[conditionCounter].selected.length > 0) {
                            conditions.push(this.selectedFilters[conditionCounter].condition)
                        }
                    }

                    // if (this.selectedFilters[0].selected.length > 0){
                    //   conditions.push("that.selectedFilters[0].selected.includes(row.type)");
                    // }
                    // if (this.selectedFilters[1].selected.length > 0){
                    //   conditions.push("that.selectedFilters[1].selected.includes(row.brand)");
                    // }
                    // if (this.selectedFilters[2].selected.length > 0){
                    //   conditions.push("that.selectedFilters[2].selected.includes(row.preposition)");
                    // }
                    // if (this.selectedFilters[3].selected.length > 0){
                    //   conditions.push("that.selectedFilters[3].selected.includes(row.verb)");
                    // }
                    // if (this.selectedFilters[4].selected.length > 0){
                    //   conditions.push("that.selectedFilters[4].selected.includes(row.adjective)");
                    // }
                    // if (this.selectedFilters[5].selected.length > 0){
                    //   conditions.push("that.selectedFilters[5].selected.includes(row.noun)");
                    // }
                    // if (this.selectedFilters[6].selected.length > 0){
                    //   conditions.push("that.selectedFilters[6].selected.includes(row.transactional)");
                    // }
                    // if (this.selectedFilters[7].selected.length > 0){
                    //   conditions.push("that.selectedFilters[7].selected.includes(row.informative)");
                    // }
                    // if (this.selectedFilters[8].selected.length > 0){
                    //   conditions.push("that.selectedFilters[8].selected.includes(row.color)");
                    // }
                    // if (this.selectedFilters[9].selected.length > 0){
                    //   conditions.push("that.selectedFilters[9].selected.includes(row.material)");
                    // }
                    var conditionString = ""
                    for (var counter = 0; counter < conditions.length; counter++) {
                        conditionString += conditions[counter]
                        if (counter < conditions.length - 1) {
                            conditionString += "&&"
                        }
                    }
                    console.log(conditionString)
                    var that = this
                    var filteredRows = this.apiRows.filter(function(row) {
                        return eval(conditionString)
                        // that.selectedFilters[1].selected.includes(row.brand) &&
                        // that.selectedFilters[2].selected.includes(row.preposition) &&
                        // that.selectedFilters[3].selected.includes(row.verb) &&
                        // that.selectedFilters[4].selected.includes(row.adjective) &&
                        // that.selectedFilters[5].selected.includes(row.noun) &&
                        // that.selectedFilters[6].selected.includes(row.transactional) &&
                        // that.selectedFilters[7].selected.includes(row.informative) &&
                        // that.selectedFilters[8].selected.includes(row.color) &&
                        // that.selectedFilters[9].selected.includes(row.material);
                    })
                    this.table1.subTitle = filteredRows.length + " keywords"
                    this.rows = filteredRows

                    this.changeFilters(filteredRows)
                }
            },
            //for table buttons
            disabled() {
                if (this.selected.length > 0) {
                    this.tableBtnDisabled = false
                    return "primary"
                } else {
                    this.tableBtnDisabled = true
                    return "grey"
                }
            },

            formatNumber(number) {
                return formatNumber(number)
            },

            addToCollection() {
                if (!this.tableBtnDisabled) {
                    if (localStorage.keywords) {
                        var kw = JSON.parse(localStorage.keywords)
                    } else {
                        var kw = []
                    }
                    var kwNoDuplicates = this.$helpers.removeDuplicatesByAttribute(this.selected.concat(kw), "keyword")
                    localStorage.setItem("keywords", JSON.stringify(kwNoDuplicates))
                    this.showAddMessage = true
                    this.$store.dispatch("CHANGE_SIDEBARMENU")
                } else {
                    this.showSelectMessage = true
                }
            },

            addToChart() {
                if (!this.tableBtnDisabled) {
                    for (var i = 0; i < this.selected.length; i++) {
                        let newData = {
                            label: this.selected[i].keyword,
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            borderColor: "grey",
                            pointBackgroundColor: "white",
                            borderWidth: 3.5,
                            pointBorderColor: "grey",
                            data: [
                                this.selected[i].January,
                                this.selected[i].February,
                                this.selected[i].March,
                                this.selected[i].April,
                                this.selected[i].May,
                                this.selected[i].June,
                                this.selected[i].July,
                                this.selected[i].August,
                                this.selected[i].September,
                                this.selected[i].October,
                                this.selected[i].November,
                                this.selected[i].December
                            ]
                        }
                        this.dataChart.datasets.unshift(newData)
                    }
                    this.selected = []
                    this.dataChart.datasets[this.dataChart.datasets.length - 1].hidden = true
                    // Hilfsvariable wird hochgezählt und Aktion in linechart.js ausgelöst
                    this.countGraph++
                } else {
                    this.showSelectMessage = true
                }
            },
            getSparklineData(ranking) {
                let monthArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                let svArray = []
                svArray[0] = ranking.January
                svArray[1] = ranking.February
                svArray[2] = ranking.March
                svArray[3] = ranking.April
                svArray[4] = ranking.May
                svArray[5] = ranking.June
                svArray[6] = ranking.July
                svArray[7] = ranking.August
                svArray[8] = ranking.September
                svArray[9] = ranking.October
                svArray[10] = ranking.November
                svArray[11] = ranking.December
                return svArray
            },

            download() {
                let fields = []
                for (let index = 0; index < this.headers.length; index++) {
                    fields.push({ label: this.headers[index].text, value: this.headers[index].value })
                }
                this.$http.post(process.env.VUE_APP_APIURL + "/research/json2csv", { data: this.keywords, columns: fields }, { headers: { Authorization: this.auth } }).then(function(response) {
                    window.location = process.env.VUE_APP_APIURL + "/" + response.body
                    this.downloaded = true
                })
            },
            fetchProducts() {
                this.rows = []
                if (this.product && this.radius) {
                    this.$http.get(process.env.VUE_APP_APIURL + "/bi/test&" + this.product + "&" + this.radius, { headers: { Authorization: this.auth } }).then(function(response) {
                        console.log(response)
                        this.items = response.body
                    })
                }
            },

            calOverallGraph(rows) {
                let jan = 0,
                    feb = 0,
                    mar = 0,
                    apr = 0,
                    may = 0,
                    jun = 0,
                    jul = 0,
                    aug = 0,
                    sep = 0,
                    oct = 0,
                    nov = 0,
                    dec = 0
                for (let index = 0; index < rows.length; index++) {
                    jan += rows[index].January
                    feb += rows[index].February
                    mar += rows[index].March
                    apr += rows[index].April
                    may += rows[index].May
                    jun += rows[index].June
                    jul += rows[index].July
                    aug += rows[index].August
                    sep += rows[index].September
                    oct += rows[index].October
                    nov += rows[index].November
                    dec += rows[index].December
                }
                this.dataChart.datasets[0].data = [jan, feb, mar, apr, may, jun, jul, aug, sep, oct, nov, dec]
                this.graphloaded = true
            },

            clearChart() {
                this.dataChart.datasets[0] = this.dataChart.datasets[this.dataChart.datasets.length - 1]
                this.dataChart.datasets.length = 1
                this.dataChart.datasets[0].hidden = false
                this.countGraph2++
            },
            generateColumnLabels(response) {
                let columnCounter = 5
                let monthArray = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
                let longMonthArray = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                this.graphOptions.annotation.annotations[0].value = response.body.keywords[0].searchvolume[0].month + " " + response.body.keywords[0].searchvolume[0].year
                this.graphloaded = true

                for (let index = 0; index < 12; index++, columnCounter++) {
                    let header = {
                        text: "Searches " + response.body.keywords[0].searchvolume[index].month + "-" + response.body.keywords[0].searchvolume[index].year,
                        value: response.body.keywords[0].searchvolume[index].month,
                        align: "center",
                        sortable: true,
                        width: "150"
                    }
                    this.headers.push(header)
                }

                let sortedYears = []
                for (let index2 = 0; index2 < 12; index2++) {
                    if (response.body.keywords[0].searchvolume[index2].month == "January") {
                        sortedYears[0] = response.body.keywords[0].searchvolume[index2].month + " " + response.body.keywords[0].searchvolume[index2].year
                    } else if (response.body.keywords[0].searchvolume[index2].month == "February") {
                        sortedYears[1] = response.body.keywords[0].searchvolume[index2].month + " " + response.body.keywords[0].searchvolume[index2].year
                    } else if (response.body.keywords[0].searchvolume[index2].month == "March") {
                        sortedYears[2] = response.body.keywords[0].searchvolume[index2].month + " " + response.body.keywords[0].searchvolume[index2].year
                    } else if (response.body.keywords[0].searchvolume[index2].month == "April") {
                        sortedYears[3] = response.body.keywords[0].searchvolume[index2].month + " " + response.body.keywords[0].searchvolume[index2].year
                    } else if (response.body.keywords[0].searchvolume[index2].month == "May") {
                        sortedYears[4] = response.body.keywords[0].searchvolume[index2].month + " " + response.body.keywords[0].searchvolume[index2].year
                    } else if (response.body.keywords[0].searchvolume[index2].month == "June") {
                        sortedYears[5] = response.body.keywords[0].searchvolume[index2].month + " " + response.body.keywords[0].searchvolume[index2].year
                    } else if (response.body.keywords[0].searchvolume[index2].month == "July") {
                        sortedYears[6] = response.body.keywords[0].searchvolume[index2].month + " " + response.body.keywords[0].searchvolume[index2].year
                    } else if (response.body.keywords[0].searchvolume[index2].month == "August") {
                        sortedYears[7] = response.body.keywords[0].searchvolume[index2].month + " " + response.body.keywords[0].searchvolume[index2].year
                    } else if (response.body.keywords[0].searchvolume[index2].month == "September") {
                        sortedYears[8] = response.body.keywords[0].searchvolume[index2].month + " " + response.body.keywords[0].searchvolume[index2].year
                    } else if (response.body.keywords[0].searchvolume[index2].month == "October") {
                        sortedYears[9] = response.body.keywords[0].searchvolume[index2].month + " " + response.body.keywords[0].searchvolume[index2].year
                    } else if (response.body.keywords[0].searchvolume[index2].month == "November") {
                        sortedYears[10] = response.body.keywords[0].searchvolume[index2].month + " " + response.body.keywords[0].searchvolume[index2].year
                    } else if (response.body.keywords[0].searchvolume[index2].month == "December") {
                        sortedYears[11] = response.body.keywords[0].searchvolume[index2].month + " " + response.body.keywords[0].searchvolume[index2].year
                    }
                }
                this.dataChart.labels = sortedYears
                this.countGraph2++
            },
            setLineChartOptions() {
                this.graphOptions.tooltips = {
                    callbacks: {
                        label: function(tooltipItems, data) {
                            return data.datasets[tooltipItems.datasetIndex].label + ": " + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index].toLocaleString()
                        }
                    }
                }
                this.graphOptions.scales = {
                    xAxes: [
                        {
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: "months"
                            }
                        }
                    ],
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: false,
                                callback: function(value, index, values) {
                                    return value.toLocaleString()
                                }
                            },
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: "Google SV"
                            }
                        }
                    ]
                }
            }
        },
        mounted() {
            // this.fetchTurnover()
            // this.setLineChartOptions();
        }
    }
</script>

<style>
    .chartCardHeading {
        padding-top: 23px;
        padding-left: 23px;
    }
    #cardtitle {
        padding-bottom: 15px;
        padding-top: 15px;
        background-color: rgb(66, 222, 250);
        color: white;
    }
    .fabicon {
        margin-left: 10px;
        margin-top: 10px;
    }
    .circularprogress {
        padding-top: 120px;
        padding-bottom: 180px;
    }
</style>
